export default __webpack_public_path__ + "static/media/img--design-5.6bc655c7.jpg";